import {
  Box,
  Button,
  InputAdornment,
  InputBase,
  Typography,
  FormControlLabel,
  Checkbox,
  styled,
  Link,
} from '@mui/material'
import { useState } from 'react'
import { RegisterModel } from 'services/types/User'
import { toast } from 'react-toastify'
import { register } from 'services/module/user'
import { ResponseBase } from 'services/responseBase'
import { useSensors } from 'hooks/useSensors'
import InputError from 'components/InputError'
import PasswordTip from './PasswordTip'
import LoadingIcon from 'components/LoadingIcon'
import { usePublicKey } from 'state/user/hooks'
import { isValidEmail } from 'utils'
import LogoIcon from 'assets/images/svg/common/logo.svg'
import PasswordShow from 'assets/images/svg/userCenter/password-show.svg'
import PasswordClose from 'assets/images/svg/userCenter/password-close.svg'
import { ReCaptchaV3 } from 'react-recaptcha-x'
import ThirdPartyLogin from '../ThirdPartyLogin'
import { useLocation } from 'react-router-dom'

const AccountPolicyControl = styled(FormControlLabel)`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  margin: 0;
  padding: 0;
  span:first-of-type {
    padding-top: 3px;
    padding-left: 0;
  }
  span:last-of-type {
    color: #ddd;
  }
`

const TermLink = styled(Link)`
  text-decoration: underline 1px solid #fff;
  font-weight: 700;
`

export default function RegisterForm({ changeStep }: { changeStep: Function }) {
  const location = useLocation()
  const [openToken, setOpenToken] = useState(false)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const { sensorsTrack } = useSensors()
  const [confirmPassword, setConfirmPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)
  const [error] = useState(true)
  const [loading, setLoading] = useState<boolean>(false)

  const [message, setMessage] = useState('')
  const publicKey = usePublicKey()
  const [checked, setChecked] = useState(false)
  // 注册提交
  const signUp = (recaptchaToken: string) => {
    setOpenToken(false)
    const invitationCode = sessionStorage.getItem('game_event_invite_code') || ''
    const activityId = sessionStorage.getItem('game_event_id') || ''

    const channel = window.sessionStorage.getItem('utm_channel') || ''
    const campaign = window.sessionStorage.getItem('utm_campaign') || ''
    const inviteCode = window.sessionStorage.getItem('utm_inviteCode') || ''
    const model = window.sessionStorage.getItem('utm_model') || ''
    const item = window.sessionStorage.getItem('utm_item') || ''
    const registerParams: RegisterModel = { password, type: 0, username: email, recaptchaToken }
    let utmReq = {}
    let sensorsUtm = {}
    if (channel || campaign || inviteCode) {
      utmReq = {
        channel,
        campaign,
        inviteCode,
        model,
        item,
      }
      sensorsUtm = {
        utm_channel: channel,
        utm_campaign: campaign,
        utm_inviteCode: inviteCode,
        utm_model: model,
        utm_item: item,
      }

      registerParams.utmReq = utmReq
    }
    const referrerUrl = window.sessionStorage.getItem('referrer_url') || ''
    registerParams.referrerUrl = referrerUrl

    console.log('create account', {
      ...sensorsUtm,
    })

    sensorsTrack('GameRegisterPopClick', {
      module: 'continue',
      register_email: email,
      game_source: window.sessionStorage.getItem('source'),
      ...sensorsUtm,
    })

    if (invitationCode) {
      registerParams.invitationCode = invitationCode
      registerParams.activityId = activityId
    }

    if (window.sessionStorage.getItem('source') !== null) {
      registerParams.source = window.sessionStorage.getItem('source')
    }
    if (location.pathname.indexOf('/referral') > -1) {
      registerParams.url = window.location.href
    }

    register(registerParams, publicKey).then((res: ResponseBase) => {
      if (res.code === 200) {
        toast.success(res.msg)
        changeStep(email, res.data)
        setLoading(false)
      } else {
        setLoading(false)
        setMessage(res.msg)
      }
    })
  }

  const verify = () => {
    if (password !== confirmPassword) {
      setLoading(false)
      setMessage('Two entered passwords do not match')
      return false
    }
    if (!isValidEmail(email)) {
      setLoading(false)
      setMessage('Please enter correct email format')
      return false
    }
    if (!publicKey) {
      setLoading(false)
      setMessage('Network Error')
      return false
    }
    const passwordReg = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/
    if (!passwordReg.test(password)) {
      setLoading(false)
      setMessage(
        'Passwords must have at least 8 characters and contain at least 1 uppercase letter, 1 lowercase letter, and 1 number'
      )
      return false
    }
    return true
  }
  return (
    <>
      <img alt="" src={LogoIcon} className="logo" />
      <Typography variant="h1" component="div">
        Welcome to Yeeha!
      </Typography>
      <InputBase
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => setEmail(event.target.value)}
        value={email}
        type="email"
        placeholder="Example@email.com"
      />
      <PasswordTip password={password}>
        <InputBase
          type={showPassword ? 'text' : 'password'}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => setPassword(event.target.value)}
          value={password}
          placeholder="Password"
          endAdornment={
            <InputAdornment
              position="end"
              onClick={() => {
                setShowPassword(!showPassword)
              }}
            >
              <img src={showPassword ? PasswordShow : PasswordClose} alt="" />
            </InputAdornment>
          }
        />
      </PasswordTip>
      <InputBase
        type={showConfirmPassword ? 'text' : 'password'}
        placeholder="Confirm password"
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => setConfirmPassword(event.target.value)}
        value={confirmPassword}
        endAdornment={
          <InputAdornment
            onClick={() => {
              setShowConfirmPassword(!showConfirmPassword)
            }}
            position="end"
          >
            <img src={showConfirmPassword ? PasswordShow : PasswordClose} alt="" />
          </InputAdornment>
        }
      />
      {/* <Typography
        variant="subtitle2"
        fontSize="14px"
        lineHeight="22px"
        color="secondary.100"
        sx={{ marginTop: '12px' }}
        component="div"
      >
        By clicking Continue, you agree with Funtaro{' '}
        <TermLink href="/protocol/terms" color="secondary.100">
          Terms of Use
        </TermLink>{' '}
        and{' '}
        <TermLink href="/protocol/privacy" color="secondary.100">
          Privacy Policy
        </TermLink>
      </Typography> */}
      <AccountPolicyControl
        checked={checked}
        onChange={(event: React.SyntheticEvent, checked: boolean) => setChecked(checked)}
        control={<Checkbox />}
        label={
          <Typography component="div" sx={{ color: '#ddd' }}>
            By clicking Create Account, you agree to be bound by Yeeha Games&nbsp;
            <TermLink href="/terms" target="_blank">
              Terms and Conditions
            </TermLink>
            &nbsp;and&nbsp;
            <TermLink href="/privacy-policy" target="_blank">
              Privacy Policy
            </TermLink>
          </Typography>
        }
      />
      <InputError error={error} message={message}></InputError>
      <Button
        color="primary"
        startIcon={loading ? <LoadingIcon theme="dark" /> : ''}
        disabled={!email || !password || !confirmPassword || !checked}
        onClick={() => {
          if (verify()) {
            setLoading(true)
            setOpenToken(true)
          }
        }}
        variant="contained"
        fullWidth
        sx={{ marginTop: '1.25rem' }}
      >
        Create Account
      </Button>
      <ThirdPartyLogin type="SignUp" />
      <Box sx={{ textAlign: 'center' }}>
        <Typography variant="body1" fontWeight="500" color="#808080" component="span">
          Already got one?
        </Typography>
      </Box>
      <Button
        onClick={() => {
          changeStep('SignIn')
        }}
        variant="outlined"
        fullWidth
        sx={{ marginTop: '1.25rem' }}
      >
        Log In
      </Button>
      {openToken && (
        <ReCaptchaV3
          action="register"
          callback={token => {
            if (typeof token === 'string') {
              signUp(token)
            }
          }}
        />
      )}
    </>
  )
}
